import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: null,
    image: null
};

const userDetailsSlice = createSlice({
    name : "userDetails",
    initialState,
    reducers:{
        StoreUser : (state , action)=>{
            state.user = action.payload;
        },
        StoreImage : (state , action)=>{
            state.image = action.payload;
        }
    }

})

export const {StoreUser, StoreImage} = userDetailsSlice.actions
export default userDetailsSlice.reducer ;